import React, { useMemo, useRef } from 'react';
import { SwiperSlide } from 'swiper/react';
import {
  CardLinkWithGAPromoClick,
  Section,
  SectionSubTitle,
  SwiperWithNavigation,
  Typography,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { Banner } from 'modules/model-json';
import { createElementKey } from 'utils';
import { removeSpecialCharacters, replaceSpecialChars } from 'utils/format';
import { PROMO_ELEMENT_BLOCK } from '../../promo-constants';
import {
  currentStoryCard,
  currentStoryImage,
  currentStoryCardName,
  currentStorySlide,
} from './current-stories-styles';

type CurrentStoriesProps = {
  banner: Banner[] | undefined;
  currentStoryTitle: string | undefined;
};

export const CurrentStories = ({ banner = [], currentStoryTitle = '' }: CurrentStoriesProps) => {
  const refs = useRef<HTMLAnchorElement[]>([]);
  const promotions = useMemo(
    () =>
      banner.map(({ title }, index: number) => ({
        name: `${PROMO_ELEMENT_BLOCK}Actual`,
        creative: removeSpecialCharacters(title),
        position: (index + 1).toString(),
      })),
    [banner]
  );

  usePromoViewEvent(refs, PROMO_ELEMENT_BLOCK, promotions);

  return (
    <Section>
      <SectionSubTitle margin="m">{currentStoryTitle}</SectionSubTitle>
      <SwiperWithNavigation slidesPerView="auto" watchOverflow>
        {banner.map(({ image, name, title, url }, index) => (
          <SwiperSlide className={currentStorySlide} key={createElementKey('current-story', index)}>
            <CardLinkWithGAPromoClick
              bannerRefs={refs}
              className={currentStoryCard}
              elementBlock={PROMO_ELEMENT_BLOCK}
              position={index}
              promotion={promotions[index]}
              href={url}
              title={title}>
              <img alt={name} className={currentStoryImage} loading="lazy" src={image} title={name} />
              <Typography
                className={currentStoryCardName}
                variant="m"
                size="body_accent"
                color="text-invert">
                {replaceSpecialChars(title)}
              </Typography>
            </CardLinkWithGAPromoClick>
          </SwiperSlide>
        ))}
      </SwiperWithNavigation>
    </Section>
  );
};
